import React, { useState } from 'react';
import logo from '../assets/images/logo.png';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsOpen(false); // Close menu on navigation
  };

  const navLinks = [
    { id: 'home', title: 'Home' },
    { id: 'about', title: 'About' },
    { id: 'services', title: 'Services' },
    { id: 'shredding', title: 'Secure Shredding' },
    { id: 'contact', title: 'Contact' },
  ];

  return (
    <>
      {/* Top Contact Bar */}
      <div className="bg-gray-800 text-white text-sm">
        <div className="container mx-auto px-6 py-2 flex flex-col md:flex-row justify-between items-center">
          <div className="flex flex-col md:flex-row gap-x-6 gap-y-1 text-center">
            <a href="tel:+14037154039" className="hover:text-blue-300">Call: +1(403)715-4039</a>
            <a href="mailto:info@bitdeploy.ca" className="hover:text-blue-300">Email: info@bitdeploy.ca</a>
          </div>
        </div>
      </div>

      {/* Main Navigation */}
      <nav className="bg-white shadow-md sticky top-0 z-50">
        <div className="container mx-auto px-6 py-3 flex justify-between items-center">
          <a href="#home" onClick={() => scrollToSection('home')} >
            <img src={logo} alt="Bitdeploy Logo" className="h-12 w-auto" />
          </a>
          {/* Desktop Menu */}
          <div className="hidden md:flex space-x-6">
            {navLinks.map(link => (
              <a key={link.id} href={`#${link.id}`} onClick={() => scrollToSection(link.id)} className="text-gray-700 hover:text-blue-600 font-medium">
                {link.title}
              </a>
            ))}
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden">
            <button onClick={() => setIsOpen(!isOpen)} className="text-gray-700 focus:outline-none">
              <svg className="h-6 w-6" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" stroke="currentColor">
                {isOpen ? <path d="M6 18L18 6M6 6l12 12" /> : <path d="M4 6h16M4 12h16M4 18h16" />}
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isOpen && (
          <div className="md:hidden bg-white border-t">
            {navLinks.map(link => (
              <a key={link.id} href={`#${link.id}`} onClick={() => scrollToSection(link.id)} className="block px-6 py-3 text-gray-700 hover:bg-gray-100">
                {link.title}
              </a>
            ))}
          </div>
        )}
      </nav>
    </>
  );
};

export default Header;
